
// src/main.ts
import * as angular from 'angular';
(window as any).angular = angular;

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { UIRouter, UrlService } from '@uirouter/core';
import { visualizer } from '@uirouter/visualizer';
import { EICDataStream3Module } from './app/app.eicDataStream3.module';
import { ConfigService } from './app/config/config.service';  // Angular service
import { runtimeConfigUrl, RUNTIME_CONFIG_FALLBACK_PATH } from './app/config/runtime-config-url';

// --- Pre-bootstrap: fetch runtime config to decide production mode ---
interface EnvironmentMeta {
  name: string;
  production: boolean;
  eap: boolean;
  requiredRole?: string;
}

interface AppConfigJson {
  appMeta: {
    environment: EnvironmentMeta;
    // diagnostics?: { debugInfoEnabled: boolean };
  };
  // other fields exist but are not needed here
}

// Using AngularJS config block, call deferIntercept()
EICDataStream3Module.config(['$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept()]);

(async () => {
  // 1) Pre-fetch the runtime config JSON to determine production mode BEFORE Angular bootstraps
  try {
    const primaryUrl = runtimeConfigUrl();
    let resp = await fetch(primaryUrl, { credentials: 'omit' });

    if (!resp.ok && primaryUrl !== RUNTIME_CONFIG_FALLBACK_PATH) {
      resp = await fetch(RUNTIME_CONFIG_FALLBACK_PATH, { credentials: 'omit' });
    }

    if (resp.ok) {
      const json = (await resp.json()) as AppConfigJson;
      (window as any).__EIC_RUNTIME_CONFIG__ = json;
      const production = !!json?.appMeta?.environment?.production;
      if (production) {
        enableProdMode();
      }
    } else {
      // If the config isn’t available, choose a safe default (no prod mode)
      // You can log or report here if desired.
      console.warn('Runtime config fetch failed; proceeding without enableProdMode()');
    }
  } catch (err) {
    console.warn('Runtime config prefetch error; proceeding without enableProdMode()', err);
  }

  // 2) Bootstrap Angular (APP_INITIALIZER will load ConfigService for the rest of the app)
  const platformRef = await platformBrowserDynamic().bootstrapModule(AppModule);

  // 3) Finish UI-Router URL setup for the hybrid app
  const urlService: UrlService = platformRef.injector.get(UIRouter).urlService;
  urlService.listen();
  urlService.sync();

  // 4) Enable ui-router-visualizer only in dev-like environments, based on runtime config
  //    Option A: read via ConfigService (available via DI post-bootstrap)
  const cfg = platformRef.injector.get(ConfigService);
  await cfg.whenReady();
  const envName = (cfg as any).environmentName ? cfg.environmentName() : cfg.appMeta().environment.name;
  if (envName === 'dev') {
    EICDataStream3Module.run(['$uiRouter', ($uiRouter) => visualizer($uiRouter)]);
    // Alternatively, enable visualizer directly from Angular side:
    // const uiRouter = platformRef.injector.get(UIRouter);
    // visualizer(uiRouter);
  }

  // 4b) (Optional) If you exposed ENVIRONMENT_META_TOKEN slice, you could use:
  // const envMeta = platformRef.injector.get(ENVIRONMENT_META_TOKEN as any) as EnvironmentMeta;
  // if (envMeta.name === 'dev') { /* enable visualizer */ }
})();





// import * as angular from 'angular';
// (window as any).angular = angular;

// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// import { UIRouter, UrlService } from '@uirouter/core';
// import { visualizer } from '@uirouter/visualizer';
// import { EICDataStream3Module } from './app/app.eicDataStream3.module';



// if (environment.production) {
//   enableProdMode();
// }

// /**
//  * This file is the main entry point for the entire app.
//  *
//  * If the application is being bundled, this is where the bundling process
//  * starts.  If the application is being loaded by an es6 module loader, this
//  * is the entry point.
//  *
//  * Point Webpack or SystemJS to this file.
//  *
//  * This module imports all the different parts of the application and registers them with angular.
//  * - Submodules
//  *   - States
//  *   - Components
//  *   - Directives
//  *   - Services
//  *   - Filters
//  *   - Run and Config blocks
//  *     - Transition Hooks
//  * - 3rd party Libraries and angular1 module
//  *
//  * Then this module creates the ng-upgrade adapter
//  * and bootstraps the hybrid application
//  */




// // Using AngularJS config block, call `deferIntercept()`.
// // This tells UI-Router to delay the initial URL sync (until all bootstrapping is complete)
// EICDataStream3Module.config(['$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept()]);

// // Manually bootstrap the Angular app
// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then(platformRef => {

//     // Intialize the Angular Module
//     // get() the UIRouter instance from DI to initialize the router
//     const urlService: UrlService = platformRef.injector.get(UIRouter).urlService;

//     // Instruct UIRouter to listen to URL changes
//     urlService.listen();
//     urlService.sync();
//   });

// // if ('serviceWorker' in navigator) {
// //   window.addEventListener('load', () => {
// //     const buildHash = Date.now();

// //     navigator.serviceWorker.register(`/azure-maps-service-worker7.js?v=${buildHash}`, { scope: '/' })
// //    // navigator.serviceWorker.register('/azure-maps-service-worker.js')
// //       .then(reg => console.log('Azure Maps Service Worker registered:', reg))
// //       .catch(err => console.error('Service Worker registration failed:', err));
// //   });
// // }


// // Show ui-router-visualizer if in dev, only
// if (environment.name === 'dev') {
//   EICDataStream3Module.run(['$uiRouter', ($uiRouter) => visualizer($uiRouter) ]);
// }




